export const SET_INSTITUTIONS = 'SET_INSTITUTIONS'
export const SET_INSTITUTIONS_META = 'SET_INSTITUTIONS_META'
export const SET_PARTICIPATE_CHAT_GROUPS = 'SET_PARTICIPATE_CHAT_GROUPS'
export const SET_GROUPS = 'SET_GROUPS'
export const SET_GROUP_SELECTED = 'SET_GROUP_SELECTED'
export const CLEAR_UNREAD_MESSAGES = 'CLEAR_UNREAD_MESSAGES'
export const SET_CURRENT_POST = 'SET_CURRENT_POST'



// WEBPACK FOOTER //
// ./src/store/modules/institution/mutation-types.js